import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';

import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { GalaxyPageModule } from '@vendasta/galaxy/page';

@Component({
  selector: 'app-stoplight',
  templateUrl: './stoplight.component.html',
  styleUrls: ['./stoplight.component.scss'],

  imports: [MatSidenavModule, GalaxyPageModule, RouterModule, MatButtonModule, MatIconModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class StoplightComponent implements OnInit {
  public basePath = '';
  public projectId = 'cHJqOjI4MjAyNw'; // Default project ID (https://vendasta.stoplight.io/settings/internal-api-documentation)

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    // First check for route data
    this.route.data.subscribe((data) => {
      if (data.projectId) {
        this.projectId = data.projectId;
      }
      if (data.basePath) {
        this.basePath = data.basePath;
      }
    });

    // Then check for query parameters which would override route data
    this.route.queryParams.subscribe((params) => {
      if (params.projectId) {
        this.projectId = params.projectId;
      }
      if (params.basePath) {
        this.basePath = params.basePath;
      }
    });
  }
}
